import type { IconSvgObject } from './types';

const UserWarning01Icon: IconSvgObject = [
  ["path", { d: "M20 21.0002C19.713 17.2691 16.7289 14.3153 12.995 14.0663L12 14C11.6446 14.0097 11.3133 14.0226 11.0008 14.0379C7.29998 14.2193 4.28416 17.3058 3.99998 21.0002", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["circle", { cx: "12", cy: "7", r: "4", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }],
  ["path", { d: "M20 6V10M20 13V13.01", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "2" }]
];

export default UserWarning01Icon;
